import React from "react";
import {
  FormDataConsumer,
  ReferenceInput,
  AutocompleteInput,
  TextInput,
  required
} from "react-admin";

const ExpiringBrokerInput = props => (
  <FormDataConsumer>
    {({ formData }) => {
      const isBusinessTypeOne =
        Number(formData?.bzTypeId) === 1;

      return (
        <TextInput
          {...props}
          source="expiringBroker"
          label="Expiring Broker"
          disabled={isBusinessTypeOne}
          validate={
            isBusinessTypeOne
              ? []
              : [required()]
          }
        />
      );
    }}
  </FormDataConsumer>
);

export default ExpiringBrokerInput;